import React, { useState, useEffect } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
// Importamos el componente genérico
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroRemitos({ 
  initialFilters = {}, 
  onSubmit = () => {}, 
  onClose = () => {} 
}) {
  // --- ESTADOS INDIVIDUALES ---
  // Inicializamos con los valores que vienen de initialFilters o valores vacíos
  const [codigo, setCodigo] = useState(initialFilters.codigo || "");
  const [numeroBoleta, setNumeroBoleta] = useState(initialFilters.numeroBoleta || "");
  const [fechaDesde, setFechaDesde] = useState(initialFilters.fechaDesde || "");
  const [fechaHasta, setFechaHasta] = useState(initialFilters.fechaHasta || "");
  const [valorVenta, setValorVenta] = useState(initialFilters.valorVenta || "");
  const [tipo, setTipo] = useState(initialFilters.tipo || "");
  const [numeroPinEess, setNumeroPinEess] = useState(initialFilters.numeroPinEess || "");
  const [numeroPinChofer, setNumeroPinChofer] = useState(initialFilters.numeroPinChofer || "");
  const [estadoId, setEstadoId] = useState(initialFilters.estadoId || "");
  const [liquidacionEjecucionId, setLiquidacionEjecucionId] = useState(initialFilters.liquidacionEjecucionId || "");
  const [tarjetaNumero, setTarjetaNumero] = useState(initialFilters.tarjetaNumero || "");

  // Autocompletes (Objetos completos)
  const [selectedCliente, setSelectedCliente] = useState(initialFilters.clienteObj || null);
  const [selectedEess, setSelectedEess] = useState(initialFilters.eessObj || null);

  // Listas para combos
  const [listaLiquidaciones, setListaLiquidaciones] = useState([]);
  const [listaEstados, setListaEstados] = useState([]);

  // Estado de carga
  const [isLoading, setIsLoading] = useState(false);

  // --- CARGA DE COMBOS ---
  useEffect(() => {
    const cargarCombos = async () => {
      try {
        // Carga paralela para mayor velocidad
        const [dataLiq, dataEst] = await Promise.all([
          appFetchJson(apiRoutes.liquidacionEjecucion.list),
          apiRoutes.estado?.listUrl 
            ? appFetchJson(apiRoutes.estado.listUrl({ size: 100, tipoId: 7 })) 
            : { items: [] }
        ]);

        setListaLiquidaciones(dataLiq?.items || []);
        setListaEstados(dataEst?.items || []);

      } catch (error) {
        console.error("Error cargando listas:", error);
      }
    };
    cargarCombos();
  }, []);

  // --- SUBMIT ---
  const handleApply = async () => {
    setIsLoading(true);

    // Construimos el objeto final
    const filtrosFinales = {
      codigo: codigo.trim(),
      numeroBoleta: numeroBoleta.trim(),
      fechaDesde: fechaDesde || null,
      fechaHasta: fechaHasta || null,
      valorVenta: valorVenta || null,
      tipo: tipo || null,
      numeroPinEess: numeroPinEess.trim(),
      numeroPinChofer: numeroPinChofer.trim(),
      estadoId: estadoId || null,
      liquidacionEjecucionId: liquidacionEjecucionId || null,
      tarjetaNumero: tarjetaNumero.trim(),
      
      // Relaciones y Objetos auxiliares
      clienteId: selectedCliente?.id || null,
      clienteObj: selectedCliente, // Para mantener la selección al reabrir
      eessId: selectedEess?.id || null,
      eessObj: selectedEess,       // Para mantener la selección al reabrir
    };

    onSubmit(filtrosFinales);
    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Remitos"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* 1. Nro Remito */}
      <div>
        <label className="form-label-fil">Nro. Remito:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          placeholder="Ej: 001-001..."
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
        />
      </div>

      {/* 2. Nro Boleta */}
      <div>
        <label className="form-label-fil">Nro. Boleta:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={numeroBoleta}
          onChange={(e) => setNumeroBoleta(e.target.value)}
        />
      </div>

      {/* 3. FECHAS (Grid 2 columnas) */}
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="form-label-fil">Fecha Desde:</label>
          <input
            type="date"
            className="input mt-1 w-full"
            value={fechaDesde}
            onChange={(e) => setFechaDesde(e.target.value)}
          />
        </div>
        <div>
          <label className="form-label-fil">Fecha Hasta:</label>
          <input
            type="date"
            className="input mt-1 w-full"
            value={fechaHasta}
            onChange={(e) => setFechaHasta(e.target.value)}
          />
        </div>
      </div>

      {/* 4. Valor Venta */}
      <div>
        <label className="form-label-fil">Valor Venta:</label>
        <input
          type="number"
          className="input mt-1 w-full"
          value={valorVenta}
          onChange={(e) => setValorVenta(e.target.value)}
        />
      </div>

      {/* 5. Tipo Operacion */}
      <div>
        <label className="form-label-fil">Tipo Operacion:</label>
        <select
          className="input mt-1 w-full"
          value={tipo}
          onChange={(e) => setTipo(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          <option value="OPERACION">OPERACION</option>
          <option value="ANULACION">ANULACION</option>
        </select>
      </div>

      {/* 6. Pin EE.SS. */}
      <div>
        <label className="form-label-fil">Pin EE.SS.:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={numeroPinEess}
          onChange={(e) => setNumeroPinEess(e.target.value)}
        />
      </div>

      {/* 7. Pin Chofer */}
      <div>
        <label className="form-label-fil">Pin Chofer:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={numeroPinChofer}
          onChange={(e) => setNumeroPinChofer(e.target.value)}
        />
      </div>

      {/* 8. Cliente */}
      <div>
        <label className="form-label-fil">Cliente:</label>
        <div className="mt-1">
          <ClienteAutocomplete
            value={selectedCliente}
            onChange={setSelectedCliente}
            placeholder="Buscar cliente..."
            className="w-full"
          />
        </div>
      </div>

      {/* 9. EE.SS. */}
      <div>
        <label className="form-label-fil">EE.SS.:</label>
        <div className="mt-1">
          <EessAutocomplete 
            value={selectedEess}
            onChange={setSelectedEess}
            placeholder="Buscar estación..."
            className="w-full"
          />
        </div>
      </div>

      {/* 10. Estado */}
      <div>
        <label className="form-label-fil">Estado:</label>
        <select
          className="input mt-1 w-full"
          value={estadoId}
          onChange={(e) => setEstadoId(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          {listaEstados.map((est) => (
            <option key={est.id} value={est.id}>
              {est.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* 11. Liquidacion Ejecucion */}
      <div>
        <label className="form-label-fil">Liquidacion Ejecucion:</label>
        <select
          className="input mt-1 w-full"
          value={liquidacionEjecucionId}
          onChange={(e) => setLiquidacionEjecucionId(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          {listaLiquidaciones.map((liq) => (
            <option key={liq.id} value={liq.id}>
              {liq.codigoLiquidacion || liq.id} {liq.dataFecha ? `(${liq.dataFecha})` : ""}
            </option>
          ))}
        </select>
      </div>

      {/* 12. Nro Tarjeta */}
      <div>
        <label className="form-label-fil">Nro. de Tarjeta:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={tarjetaNumero}
          onChange={(e) => setTarjetaNumero(e.target.value)}
        />
      </div>

    </DrawerFilter>
  );
}